export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		en: {
			users: {
				users: 'Users',
				user: 'User',
				editUser: 'Edit User',
				addNewUser: 'Add User',
				addUser: 'Add User',
				deleteUser: 'Delete User',
				filter: 'Filter users...',
				email: 'Email',
				firstname: 'First name',
				lastname: 'Last name',
				telephone: 'Telephone',
				password: 'Password',
				role: 'Role',
				roles: {
					user: 'user',
					admin: 'admin',
					developer: 'developer',
				},
				assignedProjects: 'Assigned projects',
				created: 'Created',
				userStatusDraft: 'Draft user',
				userStatusSaved: 'Saved user',
				accountDetailsTitle: 'Account details',
				accountDetailsSubtitleNew: 'Fill in to create a new user',
				accountDetailsSubtitleExisting: 'Update contact information',
				projectsBadge: '{count} projects',
				chooseProjects: 'Choose which projects this user can see.',
				showArchivedProjects: 'Show archived projects',
				filterProjects: 'Filter projects',
				noProjectsMatch: 'No projects match your search.',
				nameNotSet: 'Name not set',
				projectsSelected: '{count} selected',
				archived: 'Archived',
				save: 'Save',
				successUserAdded: 'User added successfully',
				successUserUpdated: 'User updated successfully',
				successUserDeleted: 'User deleted successfully',
			},
		},
		de: {
			users: {
				users: 'Benutzer',
				user: 'Benutzer',
				editUser: 'Benutzer bearbeiten',
				addNewUser: 'Benutzer hinzufügen',
				addUser: 'Benutzer hinzufügen',
				deleteUser: 'Benutzer löschen',
				filter: 'Benutzer filtern...',
				email: 'E-Mail',
				firstname: 'Vorname',
				lastname: 'Nachname',
				telephone: 'Telefon',
				password: 'Passwort',
				role: 'Rolle',
				roles: {
					user: 'Nutzer',
					admin: 'Admin',
					developer: 'Entwickler',
				},
				assignedProjects: 'Zugeordnete Projekte',
				created: 'Erstellt',
				userStatusDraft: 'Entwurf',
				userStatusSaved: 'Gespeichert',
				accountDetailsTitle: 'Kontodetails',
				accountDetailsSubtitleNew: 'Zum Anlegen eines neuen Benutzers ausfüllen',
				accountDetailsSubtitleExisting: 'Kontaktdaten aktualisieren',
				projectsBadge: '{count} Projekte',
				chooseProjects: 'Sichtbarkeit der Projekte für den Benutzer festlegen.',
				showArchivedProjects: 'Archivierte Projekte anzeigen',
				filterProjects: 'Projekte filtern',
				noProjectsMatch: 'Keine Projekte passen zur Suche.',
				nameNotSet: 'Name nicht gesetzt',
				projectsSelected: '{count} ausgewählt',
				archived: 'Archiviert',
				save: 'Speichern',
				successUserAdded: 'Benutzer erfolgreich hinzugefügt',
				successUserUpdated: 'Benutzer erfolgreich aktualisiert',
				successUserDeleted: 'Benutzer erfolgreich gelöscht',
			},
		},
	},
}
